import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import '../css/UpdateProfile.css'
import Alert from '../Alert'
import "../css/BackGround.css"
import AlertContext from '../context/AlertContext'
const AgentSignUp = () => {

    //UseState Hook for setting credentials of new agent
    const [credentials, setCredentials] = useState({ name: "", email: "", password: "", workingArea: "", charges: "", contactNumber: "" })


    const context = useContext(AlertContext);   // context API for custom alerts
    const { addAlert } = context;       // destructuring addAlert from AlertContext

    let navigate = useNavigate();             // for page navigation

    // Handling form submit of agent Signup
    const handleSubmit = async (e) => {

        e.preventDefault();   // to prevent loading of page on form submit

        // destructuring name,email ,password,workingArea,charges,contactNumber from credential state
        const { name, email, password, workingArea, charges, contactNumber } = credentials;

        let areaNEW = workingArea.toLowerCase();    // converting working area of agent in lowercase before insertion in db 

        // API call for new agent registration/signup
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_HOST_URL}/api/auth/agent/signup`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ name, email, password, workingArea: areaNEW, charges, contactNumber }),
            }
        );
        const json = await response.json();    // getting response 

        if (json.success) {
            // save the token and redirect
            localStorage.setItem('token', json.authtoken)
            localStorage.setItem('userType', "agent")
            addAlert({
                type: 'success',
                msg: 'User registered successfully'
            })
            navigate("/")
        }
        else    // if some error is there or agent(with passed credentials) already exists 
        {
            addAlert({
                type: 'danger',
                msg: json.error
            })
        }

    }
    const onChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value })   // setting state of credentials 
    }
    return (
        <div className='backGround'>
            <Alert />
            <div className='update-container'>
                <h3 className='mb-32 text-center'>Welcome to HomeBazaar</h3>
                <form onSubmit={handleSubmit} className='d-flex flex-column justify-content-center gap-32'>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name</label>
                        <input type="text" className="form-control" onChange={onChange} aria-describedby="emailHelp"
                            id="name" name="name" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                        <input type="email" className="form-control" onChange={onChange} aria-describedby="emailHelp"
                            id="email" name="email" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="contactNumber" className="form-label">Contact Number</label>
                        <input type="text" className="form-control" onChange={onChange} aria-describedby="emailHelp"
                            id="contactNumber" name="contactNumber" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="workingArea" className="form-label">Area</label>
                        <input type="text" pattern="[a-zA-Z]*" className="form-control" onChange={onChange} placeholder="e.g., Guwahati" aria-describedby="emailHelp"
                            id="workingArea" name="workingArea" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="charges" className="form-label">Charges(₹)</label>
                        <input type="text" pattern="^[1-9]+[0-9]*$" className="form-control" onChange={onChange} placeholder="e.g., 1000" aria-describedby="emailHelp"
                            id="charges" name="charges" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input type="password" className="form-control" onChange={onChange}
                            id="password" name="password" minLength={5} required />
                    </div>
                    <div className='flex align-self-center'>
                        <button type="submit" className="btn btn-success">Submit</button>
                    </div>
                </form>

            </div>
        </div>
    )
}

export default AgentSignUp